import React from 'react';
import InputField from 'components/pure/utils/form/InputField';

export default class KeywordSelect extends React.Component {
  constructor(props) {
    super(props);

    this.updateValue = this.updateValue.bind(this);
    this.submitValue = this.submitValue.bind(this);

    this.state = {
      value: '',
    };
  }

  updateValue(value) {
    this.setState(value);
  }

  submitValue(event) {
    event.preventDefault();
    this.props.handleAddKeyword(this.state.value);
    this.setState({value: ''});
  }

  render() {
    const {value} = this.state;
    return (
      <div>
        <form onSubmit={this.submitValue}>
          <InputField
            value={value}
            placeholder="Enter keyword"
            onChange={value => this.setState({value})}
          />
        </form>
      </div>
    );
  }
}
